export const LineSkeleton = () => {
  return (
    <div className="grid h-[52px] animate-pulse grid-cols-7 items-center justify-center border-[#EEEFF1] px-4 py-2">
      <div className="relative col-span-4 flex h-4 w-full items-center">
        <div className="flex w-[80%] flex-row items-center truncate">
          <div className="h-4 w-full rounded bg-gray-300"></div>
        </div>
      </div>

      <div className="col-span-3 flex flex-row items-center justify-between">
        <div className="flex cursor-pointer flex-row items-center justify-center space-x-1">
          <div className="h-4 w-16 rounded bg-gray-300"></div>
        </div>

        <div className="flex items-center gap-2">
          <div className="h-2 w-[32px] overflow-hidden rounded-full bg-gray-300" />
          <div className="h-4 w-4 rounded bg-gray-300"></div>
        </div>

        <div className="flex flex-row items-center justify-end space-x-2">
          <div className="h-6 w-6 rounded bg-gray-300"></div>
          <div className="h-6 w-6 rounded-full bg-gray-300"></div>
        </div>
      </div>
    </div>
  );
};
